import { Check, Close } from '@mui/icons-material';
import { Box } from '@mui/material';

interface Props {
    permissions: PermissionName[],
    permission: PermissionName,
    label: string,
    requestPermissionButton?: React.ReactNode,
}

function PermissionCheck(props : Props) {
    const { permissions, permission, label } = props;

    const hasPermission = (permissionName : PermissionName) => {
        return permissions.includes(permissionName);
    }

    return <Box>
        <Box sx={{ display: 'flex', p: 2, alignSelf: 'center', justifySelf: 'center' }}>
            <Box>
                {hasPermission(permission) ? <Check color={'success'}/> : <Close color={'error'}/>}
            </Box>
            <Box alignSelf={'center'} sx={{ ml: 2 }} flexGrow={1}>
                {label}
            </Box>
        </Box>
        {props.requestPermissionButton && !hasPermission(permission) &&
            <Box sx={{ display: 'flex', p: 2, alignSelf: 'center', justifySelf: 'center' }}>
                {props.requestPermissionButton}
            </Box>
        }
    </Box>;
}

export default PermissionCheck;